import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Button, GridColumn, GridRow, Input, Label } from "arv-reactcomponents";
import { RETURNS } from "npmlinks-constants";

import AddressBlock from "../../AddressBlock";

const { ADDR_NOT_SERVICIBLE } = RETURNS;

const ReversePickUp = props => {
  const { address, data, inner, onChecked, onSelection } = props;

  function renderView() {
    const isDisabled = address.isReturnable? "" : "disabled";
    if (Object.keys(address).length > 0) {
      return (
        <Fragment>
          <GridRow className={`nw-reversepick-addresswrapper ${isDisabled}`}>
            {!address.isReturnable && (<GridColumn className="nw-addressblockwrapper-notservicible">
              <span className="nw-addressblockwrapper-notservicibletxt">
                {ADDR_NOT_SERVICIBLE}
              </span>
            </GridColumn>)}
            <GridColumn className="nw-reversepick-addresscontainer">
              <AddressBlock.component address={address} />
            </GridColumn>
          </GridRow>
          <GridRow className="nw-reversepick-change"> 
            <GridColumn className="nw-reversepick-changeadrswraper">
              <Button
                onClick={inner}
                className="nwc-btn-primary-txt nw-reversepick-changeadrsbtn"
              >
                CHANGE ADDRESS
            </Button>
            </GridColumn>
          </GridRow>
        </Fragment>
      );
    }
    return (
      <div className="nw-reversepick-selectaddresswrapper">
        <Button
          onClick={inner}
          className="nwc-btn-primary-txt nw-reversepick-selectaddressbtn"
        >
          SELECT ADDRESS
        </Button>
      </div>
    );
  }

  return (
    <GridRow>
      <GridColumn className="nw-reversepick-wrapper">
        <Label key={data.id} htmlFor={`${data.id}-${data.name}`}>
          <Input
            id={`${data.id}-${data.name}`}
            type="radio"
            value={data.name}
            checked={onChecked}
            className="nwc-inp-radio-primary nwc-inp-xs"
            name="returns"
            onChange={() => {
              onSelection(data.name);
            }}
          />
          <div className="nw-reversepick-content">
            <span className="nw-reversepick-title">{data.displayName}</span>
            <span className="nw-reversepick-subtitle">
              {data.secondaryName}
            </span>
          </div>
          {onChecked && renderView()}
        </Label>
      </GridColumn>
    </GridRow>
  );
};

ReversePickUp.defaultProps = {
  address: {},
  inner: PropTypes.func,
};

ReversePickUp.propTypes = {
  address: PropTypes.shape({}),
  data: PropTypes.shape({}).isRequired,
  onChecked: PropTypes.bool.isRequired,
  onSelection: PropTypes.func.isRequired,
  inner: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ReversePickUp,
  component: ReversePickUp,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/ReturnComponent/ReversePickUp/index.js